import {createSlice} from "@reduxjs/toolkit";


const SetNewsSlice = createSlice({
    name: "SetNewsSlice",
    initialState: {
        title: "Новость не найдена",
        day: null,
        post: null,
        img: null
    },
    reducers: {
        setNew(state, action) {
            state.title = action.payload.title;
            state.day = action.payload.day;
            state.post = action.payload.post;
            state.img = action.payload.img;
        }
    }
})


export const {setNew} = SetNewsSlice.actions;

export default SetNewsSlice.reducer;